

<template>
  <div class="dashboard">
     <DashboardComp />
  </div>
</template>

<script >
import DashboardComp from '@/components/DashboardComp.vue'

export default{
  components: {
    DashboardComp
}
}
</script>